import React from 'react';
import Layout from '../components/Layout';
import TruckTypeList from '../components/TruckTypeList';

/**
 * Página de listado de tipos de camiones
 * Utiliza el componente Layout para mantener la estructura consistente
 * y el componente TruckTypeList para mostrar la lista de tipos de camiones
 */
const TruckTypes = () => {
  return (
    <Layout>
      <div>
        <TruckTypeList />
      </div>
    </Layout>
  );
};

export default TruckTypes;
